// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as CommonUtils$OrcaPaymentPage from "./CommonUtils.bs.js";

function parseCriteriaRule(json) {
  var dict = CommonUtils$OrcaPaymentPage.getDictFromJson(json);
  return {
          criteria_value: CommonUtils$OrcaPaymentPage.getString(dict, "criteria_value", ""),
          eligible_connectors: CommonUtils$OrcaPaymentPage.getStrArray(dict, "eligible_connectors")
        };
}

function parseSdkPaymentMethodType(json) {
  var dict = CommonUtils$OrcaPaymentPage.getDictFromJson(json);
  return {
          payment_method_type: CommonUtils$OrcaPaymentPage.getString(dict, "payment_method_type", ""),
          payment_method_criteria: CommonUtils$OrcaPaymentPage.getString(dict, "payment_method_criteria", ""),
          criteria_rules: CommonUtils$OrcaPaymentPage.getArray(dict, "criteria_rules").map(parseCriteriaRule)
        };
}

function parseSdkPaymentMethod(json) {
  var dict = CommonUtils$OrcaPaymentPage.getDictFromJson(json);
  return {
          payment_method: CommonUtils$OrcaPaymentPage.getString(dict, "payment_method", ""),
          payment_method_types: CommonUtils$OrcaPaymentPage.getArray(dict, "payment_method_types").map(parseSdkPaymentMethodType)
        };
}

function getVaultingActionFromName(name) {
  if (name === "tokenize") {
    return "Tokenize";
  } else {
    return "Skip";
  }
}

function parseProfile(json) {
  var dict = CommonUtils$OrcaPaymentPage.getDictFromJson(json);
  return {
          vaulting_action: getVaultingActionFromName(CommonUtils$OrcaPaymentPage.getString(dict, "vaulting_action", "")),
          collect_shipping_details_from_wallet_connector: CommonUtils$OrcaPaymentPage.getBool(dict, "collect_shipping_details_from_wallet_connector", false),
          collect_billing_details_from_wallet_connector: CommonUtils$OrcaPaymentPage.getBool(dict, "collect_billing_details_from_wallet_connector", true),
          always_collect_shipping_details_from_wallet_connector: CommonUtils$OrcaPaymentPage.getBool(dict, "always_collect_shipping_details_from_wallet_connector", false),
          always_collect_billing_details_from_wallet_connector: CommonUtils$OrcaPaymentPage.getBool(dict, "always_collect_billing_details_from_wallet_connector", false)
        };
}

function parseProfileAccountConfig(json) {
  var dict = CommonUtils$OrcaPaymentPage.getDictFromJson(json);
  return {
          profile: Core__Option.map(dict["profile"], parseProfile)
        };
}

function parseContextUsed(json) {
  var dict = CommonUtils$OrcaPaymentPage.getDictFromJson(json);
  return {
          profile_id: CommonUtils$OrcaPaymentPage.getOptionString(dict, "profile_id"),
          processor_merchant_id: CommonUtils$OrcaPaymentPage.getOptionString(dict, "processor_merchant_id"),
          organization_id: CommonUtils$OrcaPaymentPage.getOptionString(dict, "organization_id")
        };
}

function getCollectBillingDetailsFromWalletConnector(profile) {
  if (profile !== undefined && !profile.always_collect_billing_details_from_wallet_connector) {
    return profile.collect_billing_details_from_wallet_connector;
  } else {
    return true;
  }
}

function getCollectShippingDetailsFromWalletConnector(profile) {
  if (profile !== undefined) {
    if (profile.always_collect_shipping_details_from_wallet_connector) {
      return true;
    } else {
      return profile.collect_shipping_details_from_wallet_connector;
    }
  } else {
    return false;
  }
}

function getProfileContext(contextUsed) {
  if (contextUsed !== undefined) {
    return [
            contextUsed.profile_id,
            contextUsed.processor_merchant_id,
            contextUsed.organization_id
          ];
  } else {
    return [
            undefined,
            undefined,
            undefined
          ];
  }
}

function itemToObjMapper(json) {
  var dict = CommonUtils$OrcaPaymentPage.getDictFromJson(json);
  return {
          raw_configs: dict["raw_configs"],
          payment_methods: CommonUtils$OrcaPaymentPage.getArray(dict, "payment_methods").map(parseSdkPaymentMethod),
          account_config: Core__Option.map(dict["account_config"], parseProfileAccountConfig),
          context_used: Core__Option.map(dict["context_used"], parseContextUsed)
        };
}

function getEligibleConnectorsFromPaymentMethods(paymentMethods, paymentMethod, paymentMethodType) {
  var criteriaRules = paymentMethods.filter(function (pm) {
              return pm.payment_method === paymentMethod;
            }).flatMap(function (pm) {
            return pm.payment_method_types;
          }).filter(function (pmt) {
          return pmt.payment_method_type === paymentMethodType;
        }).flatMap(function (pmt) {
        return pmt.criteria_rules;
      });
  return Core__Array.reduce(criteriaRules, [], (function (acc, rule) {
                rule.eligible_connectors.forEach(function (connector) {
                      if (!acc.includes(connector)) {
                        acc.push(connector);
                        return ;
                      }
                      
                    });
                return acc;
              }));
}

function getPaymentExperienceFromPaymentMethods(paymentMethods, paymentMethod, paymentMethodType) {
  return Core__Array.reduce(paymentMethods.filter(function (pm) {
                        return pm.payment_method === paymentMethod;
                      }).flatMap(function (pm) {
                      return pm.payment_method_types;
                    }).filter(function (pmt) {
                    if (pmt.payment_method_type === paymentMethodType) {
                      return pmt.payment_method_criteria === "payment_experience";
                    } else {
                      return false;
                    }
                  }).flatMap(function (pmt) {
                  return pmt.criteria_rules;
                }), [], (function (acc, rule) {
                if (rule.criteria_value !== "default" && !acc.includes(rule.criteria_value)) {
                  acc.push(rule.criteria_value);
                }
                return acc;
              }));
}

export {
  parseCriteriaRule ,
  parseSdkPaymentMethodType ,
  parseSdkPaymentMethod ,
  getVaultingActionFromName ,
  parseProfile ,
  parseProfileAccountConfig ,
  parseContextUsed ,
  getCollectBillingDetailsFromWalletConnector ,
  getCollectShippingDetailsFromWalletConnector ,
  getProfileContext ,
  itemToObjMapper ,
  getEligibleConnectorsFromPaymentMethods ,
  getPaymentExperienceFromPaymentMethods ,
}
/* No side effect */
